module.exports = __webpack_public_path__ + "media/images/emblems/Schinznach_Wappen-817a52830ec2b2fc2f8dc68abe2e790a.png";